/// <reference path="../../../node_modules/@types/globalize/index.d.ts" />
/// <reference path="../htmlhelpers/htmlhelpers.ts" />

namespace Teva {
    interface InfiniteScrollOptions {
        ContainerSelector?: any;
        ResultsContainerSelector: any;

        UseInnerScroll?: boolean,
        ItemSelector: string;
        PaginationSelector: string;
        NextSelector: string;

        CustomGetContent?: any;
        OnRenderComplete?: any;
    }

    export class InfiniteScroll {
        static PageLoad() {
            $(window).off("scroll.InfiniteScroll");
            $(document.body).off("scroll.InfiniteScroll");
        }

        static GetNextPageLink(Options, Container) {
            var $NextPageLink = $(Options.NextSelector, Container);
            if ($NextPageLink.length == 0)
                $NextPageLink = null;
            return $NextPageLink;
        }

        static GetContent(Options, $NextPageLink, SuccessCallback) {
            if (Options.CustomGetContent != null)
                Options.CustomGetContent($NextPageLink, SuccessCallback);
            else {
                $.ajax({
                    method: "GET",
                    url: $NextPageLink[0].getAttribute("href"),
                    success: SuccessCallback,
                    dataType: "html"
                });
            }
        }

        static Enable(Options: InfiniteScrollOptions): void {
            var $ResultsContainer = $(Options.ResultsContainerSelector);
            var ResultsContainer = $ResultsContainer[0];
            var $PrimaryContainer = Options.ContainerSelector == null ? $ResultsContainer.closest("body, .modal-body") : $(Options.ContainerSelector);

            var $NextPageLink;
            var IsLoading = false;

            $NextPageLink = InfiniteScroll.GetNextPageLink(Options, $PrimaryContainer);
            $(Options.PaginationSelector, $PrimaryContainer).remove();
            if ($NextPageLink == null)
                return;

            var ShowNextPage = function () {
                if (IsLoading)
                    return;

                IsLoading = true;
                var Loading = document.createElement('div');
                Loading.addClass("teva-infinitescroll-loading-container");

                var LoadingChild = document.createElement('div')
                    .addClass("teva-infinitescroll-loading");
                Loading.appendChild(LoadingChild);
                ResultsContainer.appendChild(Loading);

                InfiniteScroll.GetContent(Options, $NextPageLink, function (Data) {
                    //var LoadedContainer = Options.ContainerSelector == null ? $(Data) : $(Options.ContainerSelector, Data);
                    var $LoadedContainer = $(Data);
                    var $LoadedResultsContainer = $(Options.ResultsContainerSelector, $LoadedContainer);
                    if ($LoadedResultsContainer.length == 0)
                        return;
                    var $Items = $(Options.ItemSelector, $LoadedResultsContainer);

                    if (Loading != null)
                        $(Loading).remove();

                    $NextPageLink = InfiniteScroll.GetNextPageLink(Options, $LoadedContainer);

                    $Items.each(function () {
                        $ResultsContainer.append(this);
                        var $this = $(this);
                        if ($this.is(":visible"))
                            $this.hide().fadeIn();
                    });
                    $(Options.PaginationSelector, $PrimaryContainer).remove();
                    if ($NextPageLink == null)
                        $(window).off("scroll.InfiniteScroll");
                    IsLoading = false;
                    if (Options.OnRenderComplete != null)
                        Options.OnRenderComplete();
                });
            };

            var ScrollEvent = function () {
                if (IsLoading || $NextPageLink == null)
                    return;

                var MaximumScroll, CurrentScroll;
                if (Options.UseInnerScroll == true) {
                    MaximumScroll = $ResultsContainer.offset().top - $(document.body).offset().top + $ResultsContainer.outerHeight();
                    CurrentScroll = $(window).scrollTop() + $(window).height();
                }
                else {
                    MaximumScroll = document.documentElement.scrollHeight;
                    CurrentScroll = document.documentElement.scrollTop + document.documentElement.clientHeight;//window.scrollY + document.body.offsetHeight
                }
                if (MaximumScroll != 0 && CurrentScroll >= MaximumScroll - 100)
                    ShowNextPage();
            };

            $(window).on("scroll.InfiniteScroll", ScrollEvent);
            $PrimaryContainer.on("scroll.InfiniteScroll", ScrollEvent);
            ScrollEvent();
        }
    }
}

$(document).on("Teva.PageLoad", function () {
    Teva.InfiniteScroll.PageLoad();
});
